export default __webpack_public_path__ + "static/media/preview.be372215.png";